
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Loader2, ShieldCheck } from 'lucide-react';

const CheckoutSuccessPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const tier = queryParams.get('tier');

  useEffect(() => {
    // In production, you would verify the session_id here via your API
    const timer = setTimeout(() => {
      navigate(`/listing-setup?tier=${tier}`);
    }, 3000);
    return () => clearTimeout(timer);
  }, [navigate, tier]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-12 bg-white rounded-3xl shadow-xl border border-gray-100 max-w-md w-full animate-fade-in">
         <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <ShieldCheck size={40} className="text-green-600" />
         </div>
         <h1 className="text-2xl font-black text-gray-900 mb-2">Payment Confirmed</h1>
         <p className="text-gray-500 mb-8">Your subscription is now active. We're setting up your professional environment.</p>
         
         <div className="flex items-center justify-center gap-2 text-brand-600 font-black text-xs uppercase tracking-widest">
            <Loader2 className="animate-spin" size={16} /> Initialising Listing Form
         </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
